import { scope } from "../exports/debug";
import * as toggle from "../exports/toggle";
import type { Debug } from "../exports/debug";

/**
 *
 */
export const grScope = scope("gr");

const deprScope = grScope.scope("deprecated");

const TOGGLE_PREFIX = "gr_legacy_";

const getToggleName = <T extends string>(
  type: T,
  moduleId: string,
): `${typeof TOGGLE_PREFIX}${T}_${string}` =>
  `${TOGGLE_PREFIX}${type}_${moduleId.replace(/-/g, "_")}`;

const processInvocation = (
  log: Debug,
  moduleId: string,
  funcId: string,
  message: string,
  enableToggle: string,
  reportToggle: string,
): [Error, string] => {
  const id = `gr/${moduleId}/${funcId}`;
  const dataObject = new Error(`${id}: ${message}`);

  /*                                                          */
  /*                                            */
  /*                                                       */
  /*                                                            */
  /*               */
  const caller =
    `${dataObject.stack}`
      .split("\n")
      .filter((f) => f.includes(" at "))[2]
      ?.trim() ?? `unknown script`;

  /*                                */
  log.warn(
    id,
    "is deprecated but called from",
    caller,
    "\nReporting controlled by toggle",
    reportToggle,
    "\nAvailability controlled by toggle",
    enableToggle,
  );
  return [dataObject, caller];
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function deprecated<
  /*                                                     */
  H extends (...args: any[]) => any,
  M extends string,
  F extends string,
  MSG extends string,
>(handler: H, ...meta: [moduleId: M, funcId: F, message: MSG]): H {
  const log = deprScope.scope(`${meta[0]}.${meta[1]}`);
  const toggles = [getToggleName("enable", meta[0]), getToggleName("report", meta[0])] as const;

  if (!toggle.get(toggles[0], true))
    /*                                                                         */
    return ((): unknown => {
      const [error, caller] = processInvocation(log, ...meta, ...toggles);

      if (toggle.get(toggles[1], false))
        otto.apm.sendCustomError(`assets-legacy`, error, { caller });

      throw error;
    }) as H;

  /*                                                                                           */
  return ((...args) => {
    const [dataObject, caller] = processInvocation(log, ...meta, ...toggles);

    if (toggle.get(toggles[1], false))
      otto.apm.sendCustomError(`assets-legacy`, dataObject, { caller });

    return handler(...args);
  }) as H;
}
